import api from "Helpers/Api";
import { IPagination } from "Services/pagination";

export default async function vehiclesList({
  vehicles,
  search,
  categories,
  subcategories,
  states,
  cities,
  years,
  brands,
  fuels,
  colors,
  price,
  undefinedPrices,
  published,
  page,
  perPage,
  sort,
  order,
  userId,
}: any) {
  const { data } = await api.get<IPagination<any>>("/products/", {
    params: {
      vehicles,
      search,
      categories,
      subcategories,
      states,
      cities,
      years,
      brands,
      fuels,
      colors,
      price,
      undefinedPrices,
      published,
      page,
      perPage,
      sort,
      order,
      userId,
    },
  });

  return data;
}
